/* eslint-disable prettier/prettier */
import { Travel, TravelForCustomerSupport } from 'models/customerSupport';
import { TravelDetailsVehicle } from 'models/travelDetails';

export const mapCustomerSupportTravel = (travel: TravelForCustomerSupport): Travel => ({
  flightSectors: travel.air || [],
  prices: {
    currencyCode: travel.currencyCode,
    justifyForBreakingRules: travel.justifyForBreakingRules,
    total: travel.total,
  },
  requester: {
    eticket: travel.eticket,
    fullName: travel.userFullName,
    isGuest: travel.isGuest,
    locator: travel.locator,
    requestedBy: travel.travelArrangerUserFullName || '',
    sector: travel.userGroupName,
    status: travel.travelStatus,
  },
  air: travel.isFlight
    ? {
      breakRulesMessage: [...(travel.rulesBreaked ? [''] : [])],
      expirationDate: travel.expirationDate,
      orderNumber: Number(travel.itineraryId),
    }
    : undefined,
  hotel:
    travel.isHotel && travel.hotel
      ? {
        breakRulesMessage: [...(travel.rulesBreaked ? [''] : [])],
        checkIn: travel.hotel.checkin,
        checkOut: travel.hotel.checkout,
        cityName: travel.hotel.hotelCity,
        confirmation: Number(travel.itineraryId),
        expirationDate: travel.expirationDate,
        name: travel.hotel.hotelName,
        orderNumber: Number(travel.itineraryId),
        quantityDays: travel.quantityDays,
      }
      : undefined,
  vehicle:
    travel.isVehicle && travel.vehicle
      ? ({
        breakRulesMessage: [...(travel.rulesBreaked ? [''] : [])],
        droppOffDateTime: travel.vehicle.droppOffDateTime,
        pickupDateTime: travel.vehicle.pickupDateTime,
        cityCode: travel.vehicle.vehicleCityCode,
        vehicleCityCode: travel.vehicle.vehicleCityCode,
        vehiclePickUpCityName: travel.vehicle.vehiclePickUpCityName,
        vehicleDropoffCityName: travel.vehicle.vehicleDropoffCityName,
        expirationDate: travel.expirationDate,
        carModel: travel.vehicle.vehicleModel,
        orderNumber: Number(travel.itineraryId),
        quantityDays: travel.quantityDays,
      } as TravelDetailsVehicle)
      : undefined,
  type: travel.type,
  reason: travel.reason || '',
  rejectedReason: travel.rejectedReason,
});
